import { render, staticRenderFns } from "./SustainabilityFund.vue?vue&type=template&id=9e8468e6"
import script from "./SustainabilityFund.vue?vue&type=script&lang=js"
export * from "./SustainabilityFund.vue?vue&type=script&lang=js"
import style0 from "./SustainabilityFund.vue?vue&type=style&index=0&id=9e8468e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports